enum ElectronicClientRecordClientResultOption {
  Success = 'Success',
  Failed = 'Failed',
}

export default ElectronicClientRecordClientResultOption;
